$(document).ready(function () {
  $(".megaMenuBtn").click(function () {
    $(".megaMenuBtn").not(this).removeClass("activeLink");
    $(this).toggleClass("activeLink");

    if ($(".megaMenuBtn").hasClass("activeLink")) {
      $(".closeMega").addClass("showCLose");
    } else {
      $(".closeMega").removeClass("showCLose");
    }
  });
  $(".closeMega").click(function () {
    $(".megMenuContent").removeClass("activeMegaMenu");
    $(".megaMenuBtn").removeClass("activeLink");
    $(this).toggleClass("showCLose");
  });

  $("#hamBurgerBtn").click(function () {
    $(this).toggleClass("openMenu");
    $(".customNavigatiion").toggleClass("mobileActive");
  });
});
